export default __webpack_public_path__ + "static/og-pandas-profiling-295cc266dc7a2d949399d15e15a59a94.png";